'use strict';
import { Redirect } from 'react-router-dom';
import ProcessManager from '../../../Common/Managers/ProcessManager.js';
import React, { Component } from 'react';
import Buscador from './Buscador.jsx';

class ClientSearch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            redirect: false
        }

    }

    componentDidMount() {
//        this.props.getScreenData(this.props.routeState, this.props.currentScope);
    }

    componentWillUnmount() {
        this.props.resetStateBusquedaCliente();
    }

    render() {
        if (this.props.data.redirectToVistaCliente == true)
            return <Redirect to={ProcessManager.GetNextStep("ClientSearch", "ROUTE_TO_VISTA_CLIENTE")} push />

        if (this.props.data.redirectToVistaGestionCliente == true)
            return <Redirect to={ProcessManager.GetNextStep("ClientSearch", "ROUTE_TO_GESTION_CLIENTE")} push />

        if (this.state.redirect == true)
            return <Redirect to={ProcessManager.GetNextStep("VistaCliente", "ROUTE_TO_ADMINISTRADORA")} push />

        return (
            <div className="container-fluid div-client-search-image">
                <Buscador
                    data={this.props.data}
                    obtenerClienteListado={this.props.obtenerClienteListado}
                    buscarPorCuit={this.props.buscarPorCuit}
                    cambiarBusqueda={this.props.cambiarBusqueda}
                    routeToClientView={this.props.routeToClientView}
                    buscarPorNombre={this.props.buscarPorNombre}
                    setClienteTarjetas={this.props.setClienteTarjetas}
                    buscarPorDni={this.props.buscarPorDni}
                    seleccionarCliente={this.props.seleccionarCliente}
                    routeState={this.props.routeState}
                    currentScope={this.props.currentScope}
                    getScreenData = {this.props.getScreenData}

                />
                {this.props.data.loading &&
                    <div className="loading"> Loading &#8230;</div>
                }

                {/*<GenericModal type={"WITH_COMPONENTS_AND_CLOSE_FORMOSA"} id={"okModalCuentas"} className="modal fade-out" header={"Advertencia"}
                    header={"Datos de cliente incorrectos"} component={"Debe rectificar los datos erroneos en el Sistema de Clientes de la Entidad para poder realizar el Alta de Cuenta de Tarjeta de Credito"} />*/}

            </div>
        );
    }
}

export default ClientSearch;